import {
  StyledItemContent,
  StyledRow,
  StyledRowItem,
  StyledRows,
  StyledRowSeparator,
} from "./row-item.style";
import { MDSRowItemProps, MDSRowItemSlotName } from "./row-item.types";
import { getSlot, getUnslottedChildren } from "@/mds/utils/slots";

export const MDSRowItem = ({ children, noSeparator, ...props }: MDSRowItemProps) => {
  const unslottedChildren = getUnslottedChildren(children);
  const leftAddon = getSlot(children, MDSRowItemSlotName.LeftAddon);
  const rightAddon = getSlot(children, MDSRowItemSlotName.RightAddon);
  const lastAddon = getSlot(children, MDSRowItemSlotName.LastAddon);
  const bottomAddon = getSlot(children, MDSRowItemSlotName.BottomAddon);

  return (
    <>
      <StyledRowItem {...props}>
        {leftAddon}
        <StyledRows>
          <StyledRow>
            <StyledItemContent>{unslottedChildren}</StyledItemContent>
          </StyledRow>
          {bottomAddon && <StyledRow>{bottomAddon}</StyledRow>}
        </StyledRows>
        {rightAddon}
        {lastAddon}
      </StyledRowItem>
      {!noSeparator && <StyledRowSeparator />}
    </>
  );
};
